import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import InternalTicketsPanel from "../InternalTicketsPanel";

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: "100%",
    maxWidth: 820,
    borderRadius: 16
  },
  titleRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  dialogContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2)
  }
}));

const InternalTicketsModal = ({
  open,
  onClose,
  ticketId,
  internalTickets,
  onRefresh
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle disableTypography className={classes.titleRoot}>
        <span>Tickets internos</span>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <InternalTicketsPanel
          ticketId={ticketId}
          internalTickets={internalTickets}
          onRefresh={onRefresh}
          embedded={false}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InternalTicketsModal;
